(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    class AccordionGroup extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('[data-accordion-row]'));
      this.singleOpen = this.dataset.singleOpen === 'true';

      this.rows.forEach((row) => {
        const button = row.querySelector('.accordion-row__question');
        const panel = row.querySelector('.accordion-row__panel');
        if (!button || !panel) return;

        button.addEventListener('click', () => {
          const isOpen = row.classList.contains('is-open');

          if (this.singleOpen && !isOpen) {
            this.rows.forEach((other) => {
              if (other !== row) this.setState(other, false);
            });
          }

          this.setState(row, !isOpen);
        });
      });
    }

    setState(row, open) {
      const button = row.querySelector('.accordion-row__question');
      const panel = row.querySelector('.accordion-row__panel');
      const inner = row.querySelector('.accordion-row__panel-inner');
      if (!button || !panel || !inner) return;

      row.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      panel.style.maxHeight = open ? `${inner.scrollHeight}px` : '0px';
    }
  }

  if (!customElements.get('accordion-group')) {
    customElements.define('accordion-group', AccordionGroup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-bundle"] && !Shopify.designMode) return;
  try {
    class ProductBundle extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      const data = this.querySelector('[data-bundle-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.tiers = Array.from(this.querySelectorAll('[data-bundle-tier]'));

      if (!this.tiers.length) return;

      this.tiers.forEach((tier) => {
        tier.querySelector('.bundle-tier__input').addEventListener('change', () => this.onTierChange(tier));
        tier.querySelectorAll('[data-bundle-option]').forEach((select) => {
          select.addEventListener('change', () => {
            this.updateUnitImage(select.closest('[data-bundle-unit]'));
            this.render();
          });
        });
      });

      if (!this.tiers.some((tier) => tier.querySelector('.bundle-tier__input').checked)) {
        this.tiers[0].querySelector('.bundle-tier__input').checked = true;
      }

      this.tiers.forEach((tier) => {
        tier.querySelectorAll('[data-bundle-unit]').forEach((unit) => this.updateUnitImage(unit));
      });

      this.render();
      this.emit();
    }

    get selectedTier() {
      return this.tiers.find((tier) => tier.querySelector('.bundle-tier__input').checked) || this.tiers[0];
    }

    unitVariant(unit) {
      const selects = Array.from(unit.querySelectorAll('[data-bundle-option]'));
      if (!selects.length) return this.variants[0];
      const chosen = selects.map((select) => select.value);
      return (
        this.variants.find((variant) =>
          chosen.every((value, index) => String(variant.options[index]) === String(value))
        ) || this.variants[0]
      );
    }

    tierUnits(tier) {
      const units = Array.from(tier.querySelectorAll('[data-bundle-unit]'));
      if (units.length) return units.map((unit) => this.unitVariant(unit));

      const quantity = Number(tier.dataset.quantity) || 1;
      return Array.from({ length: quantity }, () => this.variants[0]);
    }

    tierPricing(tier) {
      const units = this.tierUnits(tier);
      const listTotal = units.reduce((sum, variant) => sum + (variant ? variant.price : 0), 0);
      const compareTotal = units.reduce(
        (sum, variant) => sum + (variant ? variant.compare_at_price || variant.price : 0),
        0
      );

      const override = Number(tier.dataset.totalPrice) || 0;
      const price = override > 0 ? override : listTotal;
      const compareAt = compareTotal > price ? compareTotal : 0;

      return { price, compareAt, units };
    }

    updateUnitImage(unit) {
      if (!unit) return;
      const image = unit.querySelector('[data-bundle-unit-image]');
      if (!image) return;
      const variant = this.unitVariant(unit);
      if (variant && variant.featured_image && variant.featured_image.src) {
        image.src = variant.featured_image.src;
      }
    }

    render() {
      this.tiers.forEach((tier) => {
        const { price, compareAt } = this.tierPricing(tier);
        const saved = compareAt > price ? compareAt - price : 0;
        const savedPercent = compareAt > 0 ? Math.round((saved * 100) / compareAt) : 0;

        const priceEl = tier.querySelector('[data-tier-price]');
        const compareEl = tier.querySelector('[data-tier-compare]');
        if (priceEl) priceEl.textContent = window.formatMoney(price);
        if (compareEl) compareEl.textContent = compareAt > 0 ? window.formatMoney(compareAt) : '';

        ['[data-tier-label]', '[data-tier-subtitle]'].forEach((selector) => {
          const el = tier.querySelector(selector);
          if (!el) return;
          if (!el.dataset.template) el.dataset.template = el.textContent.trim();
          el.textContent = el.dataset.template
            .replace('[saved_amount]', window.formatMoney(saved))
            .replace('[saved_percent]', `${savedPercent}%`);
          el.hidden = saved <= 0 && el.dataset.template.includes('saved');
        });
      });
    }

    onTierChange() {
      this.render();
      this.emit();
    }

    emit() {
      const tier = this.selectedTier;
      const { price, compareAt, units } = this.tierPricing(tier);

      document.dispatchEvent(
        new CustomEvent('chroma:selection-change', {
          detail: {
            price,
            compareAtPrice: compareAt,
            quantity: units.length,
            variantId: units[0] ? units[0].id : null,
            featuredMediaId: units[0] && units[0].featured_media ? units[0].featured_media.id : null
          }
        })
      );
    }

    getCartPayload() {
      const tier = this.selectedTier;
      const units = this.tierUnits(tier);
      const grouped = new Map();

      units.forEach((variant) => {
        if (!variant) return;
        grouped.set(variant.id, (grouped.get(variant.id) || 0) + 1);
      });

      const items = Array.from(grouped.entries()).map(([id, quantity]) => ({ id, quantity }));

      const giftId = tier.dataset.giftVariant;
      if (giftId) items.push({ id: Number(giftId), quantity: 1 });

      return { items, discountCode: tier.dataset.discountCode || '' };
    }
  }

  if (!customElements.get('product-bundle')) {
    customElements.define('product-bundle', ProductBundle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    class BuyButtons extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      this.textEl = this.querySelector('[data-atc-text]');
      this.spinner = this.querySelector('.loading__spinner');
      this.errorEl = this.querySelector('[data-product-form-error]');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.quantityInput = this.querySelector('[data-quantity-input]');
      this.showPrice = this.dataset.showPrice === 'true';
      this.baseLabel = this.textEl ? this.textEl.textContent.trim() : '';

      this.form.addEventListener('submit', (event) => this.onSubmit(event));

      document.addEventListener('chroma:selection-change', (event) => this.onSelectionChange(event.detail));
    }

    get bundle() {
      return document.querySelector('product-bundle');
    }

    onSelectionChange(detail) {
      if (!detail) return;

      if (detail.variantId) this.variantInput.value = detail.variantId;
      if (detail.quantity) this.quantityInput.value = detail.quantity;

      if (this.showPrice && typeof detail.price === 'number') {
        let markup = `${this.baseLabel} <span class="buy-buttons__price">${window.formatMoney(detail.price)}</span>`;
        if (detail.compareAtPrice > detail.price) {
          markup += `<span class="buy-buttons__compare">${window.formatMoney(detail.compareAtPrice)}</span>`;
        }
        this.textEl.innerHTML = markup;
      }

      if (typeof detail.available === 'boolean') {
        this.button.disabled = !detail.available;
      }
    }

    setLoading(loading) {
      this.button.setAttribute('aria-disabled', String(loading));
      if (this.spinner) this.spinner.classList.toggle('hidden', !loading);
      if (this.textEl) this.textEl.style.visibility = loading ? 'hidden' : 'visible';
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    onSubmit(event) {
      if (window.themeSettings && window.themeSettings.cartType !== 'drawer') {
        if (!this.bundle) return;
      }

      event.preventDefault();
      if (this.button.getAttribute('aria-disabled') === 'true') return;

      this.setLoading(true);
      if (this.errorEl) this.errorEl.hidden = true;

      const bundle = this.bundle;
      const payload = bundle
        ? bundle.getCartPayload()
        : { items: [{ id: Number(this.variantInput.value), quantity: Number(this.quantityInput.value) || 1 }] };

      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload.items, sections: window.sectionsToRequest() })
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || response.message);
            return null;
          }

          if (payload.discountCode) {
            window.location.href = `/discount/${encodeURIComponent(payload.discountCode)}?redirect=${
              window.themeSettings.cartType === 'drawer' ? window.location.pathname : '/cart'
            }`;
            return null;
          }

          return fetch(`${window.routes.cart_url}.js`)
            .then((r) => r.json())
            .then((cart) => {
              const drawer = document.querySelector('cart-drawer');
              if (drawer) {
                drawer.renderContents({ item_count: cart.item_count, sections: response.sections });
              } else {
                window.location.href = window.routes.cart_url;
              }
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            });
        })
        .catch(() => this.showError(window.cartStrings.error))
        .finally(() => this.setLoading(false));
    }
  }

  if (!customElements.get('buy-buttons')) {
    customElements.define('buy-buttons', BuyButtons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-price"] && !Shopify.designMode) return;
  try {
    class ProductPriceBlock {
    constructor(root) {
      this.root = root;
      this.current = root.querySelector('[data-price-current]');
      this.compare = root.querySelector('[data-price-compare]');
      this.badge = root.querySelector('[data-price-badge]');
      this.badgeText = root.querySelector('[data-price-badge-text]');
      this.format = root.dataset.saveFormat;

      document.addEventListener('chroma:selection-change', (event) => this.update(event.detail));
    }

    update(detail) {
      if (!detail || typeof detail.price !== 'number') return;

      const price = detail.price;
      const compareAt = detail.compareAtPrice || 0;

      this.current.textContent = window.formatMoney(price);

      if (compareAt > price) {
        this.compare.textContent = window.formatMoney(compareAt);
        this.compare.hidden = false;

        if (this.badge) {
          const saved = compareAt - price;
          this.badgeText.textContent =
            this.format === 'percent'
              ? `Save ${Math.round((saved * 100) / compareAt)}%`
              : `Save ${window.formatMoney(saved)}`;
          this.badge.hidden = false;
        }
      } else {
        this.compare.hidden = true;
        if (this.badge) this.badge.hidden = true;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-price-block]').forEach((block) => new ProductPriceBlock(block));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variant-picker-data]');
      this.variants = data ? JSON.parse(data.textContent) : [];

      this.addEventListener('change', () => this.onChange());
      this.onChange(true);
    }

    selectedValues() {
      const dropdowns = Array.from(this.querySelectorAll('select[data-option-position]'));
      if (dropdowns.length) return dropdowns.map((select) => select.value);
      return Array.from(this.querySelectorAll('.variant-picker__input:checked')).map((input) => input.value);
    }

    onChange(initial) {
      const values = this.selectedValues();
      const variant = this.variants.find((candidate) =>
        values.every((value, index) => String(candidate.options[index]) === String(value))
      );

      values.forEach((value, index) => {
        const label = this.querySelector(`[data-selected-value="${index + 1}"]`);
        if (label) label.textContent = value;
      });

      if (!variant) {
        document.dispatchEvent(
          new CustomEvent('chroma:selection-change', { detail: { available: false, quantity: 1 } })
        );
        return;
      }

      if (!initial) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      document.dispatchEvent(
        new CustomEvent('chroma:selection-change', {
          detail: {
            variantId: variant.id,
            quantity: 1,
            price: variant.price,
            compareAtPrice: variant.compare_at_price || 0,
            available: variant.available,
            featuredMediaId: variant.featured_media ? variant.featured_media.id : null
          }
        })
      );

      document.dispatchEvent(
        new CustomEvent('chroma:variant-change', {
          detail: { featuredMediaId: variant.featured_media ? variant.featured_media.id : null }
        })
      );
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-viewers"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-viewers]').forEach((root) => {
      const counter = root.querySelector('[data-viewers-count]');
      if (!counter) return;

      const min = Number(root.dataset.min) || 20;
      const max = Number(root.dataset.max) || 60;
      let value = Math.floor(Math.random() * (max - min + 1)) + min;
      counter.textContent = value;

      setInterval(() => {
        const change = (Math.floor(Math.random() * 3) + 1) * (Math.random() > 0.5 ? 1 : -1);
        value = Math.min(max, Math.max(min, value + change));
        counter.textContent = value;
      }, Math.floor(Math.random() * 3000) + 5000);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-carousel"] && !Shopify.designMode) return;
  try {
    class VideoCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-video-slide]'));
      this.autoplay = this.dataset.autoplay === 'true';

      this.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        const playButton = slide.querySelector('[data-video-play]');
        const soundButton = slide.querySelector('[data-video-sound]');

        if (playButton) {
          playButton.addEventListener('click', () => {
            if (!video) return;
            video.play();
            slide.classList.add('is-playing');
          });
        }

        if (soundButton && video) {
          soundButton.addEventListener('click', () => {
            video.muted = !video.muted;
            soundButton.innerHTML = video.muted
              ? soundButton.dataset.mutedIcon || soundButton.innerHTML
              : soundButton.innerHTML;
            soundButton.setAttribute('aria-pressed', String(!video.muted));
            soundButton.classList.toggle('is-unmuted', !video.muted);
          });
        }
      });

      if (this.autoplay) this.observeSlides();
    }

    observeSlides() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting) {
              video.muted = true;
              const attempt = video.play();
              if (attempt && attempt.catch) attempt.catch(() => {});
              entry.target.classList.add('is-playing');
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.4 }
      );

      this.slides.forEach((slide) => observer.observe(slide));
    }
  }

  if (!customElements.get('video-carousel')) {
    customElements.define('video-carousel', VideoCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
